const COOKIE_NAME = 'syncehs_device_token';
const TOKEN_LENGTH = 32; // 32 bytes = 64 hex chars
const COOKIE_MAX_AGE_DAYS = 30;

export function generateDeviceToken(): string {
  const bytes = new Uint8Array(TOKEN_LENGTH);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function getDeviceToken(): string | null {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  return match ? match.split('=')[1] : null;
}

export function setDeviceToken(token: string): void {
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${token}; max-age=${maxAge}; path=/; SameSite=Strict; Secure`;
}

export function clearDeviceToken(): void {
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Strict; Secure`;
}

export function getDeviceName(): string {
  const ua = navigator.userAgent;

  let browser = 'Unknown Browser';
  if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/') && !ua.includes('Edg/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome/')) browser = 'Safari';

  let os = 'Unknown OS';
  if (ua.includes('iPhone') || ua.includes('iPad')) os = ua.includes('iPad') ? 'iPad' : 'iPhone';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Linux')) os = 'Linux';

  return `${browser} on ${os}`;
}

export function normalizePhone(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  let e164: string;

  if (digits.length === 10) {
    e164 = `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    e164 = `+${digits}`;
  } else {
    return null;
  }

  if (!/^\+1\d{10}$/.test(e164)) {
    return null;
  }

  return e164;
}
